// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"1dd4b502","824":"85856bcd"}[chunkId] + ".chunk.css";
};